"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_2 = __importDefault(require("react"));
var styles_1 = require("../../../../styles");
var BaseStyle = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  background: ", ";\n"], ["\n  border: 1px solid ", ";\n  background: ", ";\n"])), styles_1.COLOR.border.base, styles_1.COLOR.background.white);
var ErrorStyle = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  background: ", ";\n"], ["\n  border: 1px solid ", ";\n  background: ", ";\n"])), styles_1.COLOR.border.error, styles_1.COLOR.background.error);
var DisabledStyle = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  background: ", ";\n"], ["\n  border: 1px solid ", ";\n  background: ", ";\n"])), styles_1.COLOR.border.base, styles_1.COLOR.background.disabled);
var StyledWrapper = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: ", ";\n  ", "\n\n  label: Wrapper;\n"], ["\n  border-radius: 4px;\n  padding: ", ";\n  ", "\n\n  label: Wrapper;\n"])), function (_a) {
    var padding = _a.padding;
    return padding;
}, function (_a) {
    var disabled = _a.disabled, error = _a.error;
    if (disabled) {
        return DisabledStyle;
    }
    return error ? ErrorStyle : BaseStyle;
});
var Wrapper = function (_a) {
    var children = _a.children, disabled = _a.disabled, error = _a.error, padding = _a.padding;
    return (react_2.default.createElement(StyledWrapper, { disabled: disabled, error: error, padding: padding }, children));
};
exports.Wrapper = Wrapper;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
